const products = [
    {
        key: "bed73bb2-8a8e-11ed-a1eb-0252ac120002",
        id: "1",
        title: "کمپرسور اسکرو اویل اینجکت",
        descriptoin: "کمپرسورها از لحاظ عملکردی به دو نوع مکانیکی و جابه‌جایی مثبت تقسیم می‌شوند؛ کمپرسور اسکرو از نوع جابه‌جایی مثبت است. کلمه اسکرو (Screw) در زبان فارسی به معنای پیچیدن، تاب دادن یا پیچاندن است و استفاده از این کلمه بعد از واژه کمپرسور اشاره به نوع چرخ‌دنده‌هایی دارد که کار تراکم هوا را انجام می‌دهند. در واقع هوا توسط چرخ‌دنده‌ها مکش شده و در حین چرخش آنها، هوا متراکم می‌شود.",
        briefTitle: "اطلاعات فنی",
        briefDescription: "کمپرسور اسکرو نیز مانند هر کمپرسوری انواع مخصوص به خود را دارد. البته این نکته را باید اشاره کرد که شرکت‌های سازنده بنا به سیاست خود این کمپرسور را به انواع مختلف تقسیم‌بندی می‌کنند، به طور مثال براساس سایز مخزن یا سیستم محرک چرخ دنده‌ها.اما به ‌طور کلی دو نوع کمپرسور اسکرو وجود دارد؛ کمپرسور اسکرو روغنی و بدون روغن. تفاوت این دو نوع کمپرسور در استفاده از روغن در محفظه تراکم است.برخی از صنایع(به طور مثال دندانپزشکی و داروسازی) نیازمند به هوای خالص و عاری از هرگونه آلودگی هستند؛ برای همین منظور باید در محفظه تراکم و زمانی که چرخ‌دنده‌ها هوا را متراکم می‌کنند از روغن برای روان کاری استفاده نشود.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "ما در ﺷﺮﮐﺖ هواﯾﺎر در ﻃﺮاﺣﯽ اوﻟﯿﻪ و ﺗﻮﻟﯿﺪ ﮐﻤﭙﺮﺳﻮر اﺳﮑﺮو ﻣﻌﻤﻮﻻً در ﻣﺤﺪودهkW/HP کوچک‌تر، ﺗﺎ ﺗﻮﻟﯿﺪ ﮐﻤﭙﺮﺳﻮرهای دور ﻣﺘﻐﯿﺮ (ﻓﺮﮐﺎﻧﺲ) در ﮐﻨﺎر ﻣﺸﺘﺮﯾﺎن هستیم. اﻟﺒﺘﻪ ﺳﯿﺴﺘﻢ‌های دور ﻣﺘﻐﯿﺮ ﮔﺮان‌ﺗﺮ هستند اﻣﺎ ﺑﻪ ﻃﻮر ﻣﻌﻤﻮل هزینه‌های اوﻟﯿﻪ را ﺑﺎ ﺻﺮﻓﻪ‌ﺟﻮﯾﯽ در ﻣﺼﺮف اﻧﺮژی ﺟﺒﺮان ﻣﯽ‌ﮐﻨﻨﺪ. ﮐﻤﭙﺮﺳﻮر اﺳﮑﺮو ﺳﺮﻋﺖ ﻣﺘﻐﯿﺮ ﺑﺮاي همه تجهیزات دارای ﻧﻮﺳﺎن ﺟﺮﯾﺎن، ﮔﺰﯾﻨﻪ ﺑﺴﯿﺎر ﺧﻮﺑﯽ هستند. اﯾﻦ اﻣﺮ ﺑﻪ وﯾﮋه زﻣﺎﻧﯽ ﺻﺪق ﻣﯽﮐﻨﺪ ﮐﻪ در ﻃﻮل روز ﭼﻨﺪﯾﻦ ﺟﺎﺑﺠﺎﯾﯽ تأﺳﯿﺴﺎت داﺷﺘﻪ ﺑﺎﺷﯿﺪ و در ﺟﺎﯾﯽ ﮐﻪ ﺗﻘﺎﺿﺎی ﺟﺮﯾﺎن در ﻃﻮل روز اﻓﺰاﯾﺶ و ﮐﺎهش ﻣﯽ‌ﯾﺎﺑﺪ. ﺑﺎ ﺗﻮﺟﻪ ﺑﻪ اﯾﻨﮑﻪ ﻣﺼﺮف هوای ﻓﺸﺮده ﻣﯽﺗﻮاﻧﺪ ﭘﺮهزﯾﻨﻪ ﺑﺎﺷﺪ و ﺑﯿﺶ از 70 درﺻﺪ ﮐﻞ هزﯾﻨﻪ ﺑﺮق را ﺑﻪ ﺧﻮد اﺧﺘﺼﺎص دهد، اﺳﺘﻔﺎده از ﻓﻨﺎوری ﺳﺮﻋﺖ ﻣﺘﻐﯿﺮ ﻣﯽ‌ﺗﻮاﻧﺪ در دﺳﺘﯿﺎﺑﯽ ﺑﻪ ﺻﺮﻓﻪ ﺟﻮﯾﯽ 35 ﺗﺎ 50 درﺻﺪ ﺑﻪ ﺷﻤﺎ ﮐﻤﮏ ﮐﻨﺪ. ﮐﻤﭙﺮﺳﻮرهای هوای دور ﻣﺘﻐﯿﺮ ﺑﺎ ﻣﯿﺰان ﺟﺮﯾﺎن (Flow) ﻣﻮرد ﻧﯿﺎز ﻣﻄﺎﺑﻘﺖ دارﻧﺪ. ﺑﻪ ﻋﺒﺎرت ﺳﺎدهﺗﺮ، ﮐﻤﭙﺮﺳﻮر اسکرو ﻣﯽ‌ﺗﻮاﻧﺪ ﻣﯿﺰان ﺟﺮﯾﺎن ﻣﻮرد اﺳﺘﻔﺎده را ﺣﺲ ﮐﻨﺪ و ﺑﺮ اﯾﻦ اﺳﺎس ﺳﺮﻋﺖ ﺧﻮد را ﺗﻨﻈﯿﻢ ﮐﻨﺪ، ﺗﺎ ﻓﻘﻂ ﺧﺮوج هوای ﻣﻮرد ﻧﯿﺎز ﻣﺼﺮف را اﺟﺎزه ﺑﺪهد. ﮐﻤﭙﺮﺳﻮرهای هوای دور ﻣﺘﻐﯿﺮ (VSD) بسیاری از ﻣﺸﺘﺮﯾﺎن را از ﺻﺮﻓﻪ‌ﺟﻮﯾﯽ انرژی سالانه و داشتن توانایی سرمایه‌گذاری مجدد پول در دارایی‌های دیگر بهره‌مند می‌کند.",
        imageAddress: "../assets/images/sample/screw.jpg",
        imageSquareAddress: "../assets/images/sample/sscrew.jpg",
        url: "/ProductDetail",
        category: { value: "1", label: "کمپرسور" },
        equpment: "کمپرسور",
        compressorParameters: {
            isAir:"true",
            isGas: "false",
            isOilInject :"true",
            compresorType: "1",
            motorPower: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
            coolingSystem: [1, 2],
            beltDrive: [1, 2, 3]
        },
        tankParameters: {
            size: ""
        },
        isHasCatalog: "true",
        isHasDataSheet: "false",
        catalogUrl: "../assets/pdf/ScrewCompressor-OilInjected.pdf",
        dataSheetUrl: "",
        detailTitle1: "Power",
        detailDescription1: "(Kw)15~500",
        detailTitle2: "Pressure",
        detailDescription2: "(bar-g)7~15",
        detailTitle3: "Flow",
        detailDescription3: "(m³/min)1.8~85"
    },
    {
        key: "bed73bb2-8a8e-11ed-a1eb-0242ac120002",
        id: "15",
        title: "کمپرسور اسکرو بدون روغن",
        descriptoin: "یکی از محصولات تولیدی در هوایار کمپرسور اسکرو بدون روغن (Oil Free Compressor) می‌باشد؛ این کمپرسور که معمولاً به صورت دو مرحله‌ای ساخته می‌شوند در آنها هیچ نوع تزریق روغن به داخل محفظه فشرده سازی وجود ندارد و هوای فشرده تولید شده کاملاً عاری از روغن است. این کمپرسورها به دلیل تولید هوای کاملاً تمیز و بازه‌های فشاری متنوع استفاده گسترده‌ای در صنایع مختلف دارند.",
        briefTitle: "اطلاعات فنی",
        briefDescription: "هوای فشرده عاری از ذرات روغن در صنایع متنوعی مورد استفاده قرار می‌گیرد، صنایعی که کیفیت هوا در فرآیند خط تولید و محصول نهایی آن از اهمیت بالایی برخوردار است. این صنایع شامل غذایی و آشامیدنی، صنعت داروسازی (ساخت و بسته بندی)، نفت، گاز و پتروشیمی، تولید قطعات نیمه هادی و الکتریکی، بخش پزشکی، اسپری رنگ خودرو، نساجی و تولید پارچه و بسیاری از دیگر بخش‌هاست. در این صنایع حساس، آلودگی حتی با کمترین مقادیر روغن می‌تواند منجر به خرابی خط تولید و کل محصول نهایی گردد.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "ویژگی های کمپرسور اسکرو بدون روغن هوایار: ۱- تنظیم راحت و آسان ۲- طراحی سیستم به صورت Silence 3- صد درصد هوای خالص ۴- صرفه جویی در انرژی ۵- کاهش هزینه‌های تعمیر و نگهداری ۶- کاهش هزینه‌های عملیاتی ۷- اطمینان از کیفیت هوای خروجی ۸- تغییر دور متناسب با شرایط کاری و ...    کمپرسورهای HF هوایار به گونه‌ای طراحی و مهندسی شده‌اند تا فونداسیونی کارا بر رفع نیازهای اصلی صنعت و کسب و کار شما باشد، تنها این کمپرسورها، هوای فشرده‌ی پایدار و بیشتری علی‌رغم مصرف بهینه انرژی، تولید و در اختیار شما قرار می‌دهند.طراحی متفاوت و ساختار نوآورانه آنها اعتماد و آسودگی خاطر با سرویس و نگهداری آسان را به همراه دارد.",
        imageAddress: "../assets/images/sample/OilFree.png",
        imageSquareAddress: "../assets/images/sample/OilFreeSquare.png",
        url: "/ProductDetail",
        category: { value: "1", label: "کمپرسور" },
        equpment: "کمپرسور",
        compressorParameters: {
            isAir: "true",
            isGas: "false",
            isOilInject: "false",
            compresorType: "1",
            motorPower: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
            coolingSystem: [1, 2],
            beltDrive: [1, 2, 3]
        },
        tankParameters: {
            size: ""
        },
        isHasCatalog: "true",
        isHasDataSheet: "false",
        catalogUrl: "../assets/pdf/Oil-Free-Compressor.pdf",
        dataSheetUrl: "",
        detailTitle1: "Power",
        detailDescription1: "(Kw)45~355",
        detailTitle2: "Pressure",
        detailDescription2: "(bar-g)7.5~10.5",
        detailTitle3: "Flow",
        detailDescription3: "(m³/min)5.2~50"
    },
    {
        key: "bed73bb2-8a8e-11ed-a1eb-0252ac120102",
        id: "18",
        title: "کمپرسور اسکرو گاز",
        descriptoin: "کمپرسور اسکرو گاز فرآیندی (process gas screw compressor) بر اساس استاندارد API 619 به ویژه برای الزامات ایمنی بالای فشرده سازی گاز و سرد سازی فرایند در صنایع نفت، گاز و پتروشیمی طراحی شده‌ است. کمپرسور اسکرو گاز فرایندی روغنی از طریق مکش  گاز به داخل فضاهای بین روتور عمل می‌کند؛ با حرکت پیچشی روتورها، گاز توسط روتور به یک فضا با حجم کمتر وارد می‌شود و درخروجی گاز به فشار بالا می‌رسد. process gas compressor مجهز به بدنه Casing با متریال Cast Steel، بیرینگ محوری از نوع Titling Pad بدون نیاز به تعمیرات، Double Shaft Seal، Monitoring وضعیت روتور و کنترل دما Sleeve Bearing برای اطمینان از عملکرد مطمئن کمپرسور می‌باشد.",
        briefTitle: "اطلاعات فنی",
        briefDescription: "کمپرسور اسکرو گاز برای فشرده سازی و ذخیره سازی گاز طبیعی و گازهای مبرد در فرایند Refrigeration و همچنین برای فشرده سازی گازهای فرایندی هیدروکربنی طراحی شده است.  .کمپرسور اسکرو گاز فرآیندی روغنی برای کاربردهای فرایندی طراحی شده‌ است و شرکت هوایار تعداد بالایی از کمپرسورهای Oil Inject را به شکل Skid Mounted تولید می‌نماید این کمپرسورهای گاز فرآیند دارای ویژگی‌های کلیدی و منحصر به فردی هستند؛ راندمان عملکردی بالا و فشار بالای خروجی این کمپرسورها از فاکتور‌های کلیدی طراحی آنها می‌باشد.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "هوایار علاوه بر کمپرسور اسکرو گاز روغنی فرایندی قادر است که کمپرسور گاز اسکرو بدون روغن را نیز ارائه نماید. فناوری کمپرسورهای اسکرو گاز عاری از روغن در موقعیت‌های زیادی به کار می‌روند. کمپرسورهای اسکرو بدون روغن در متریال‌ها و حالت‌های مختلفی از سیال گاز ورودی قابل دسترس می‌باشند و گازهای با سطوح بالای مایع، کثیف و حاوی ذرات اجازه ورود به کمپرسور را خواهند داشت. متریال این کمپرسورها متناسب با گازهای خطرناک یا خورنده و یا همچنین در مواردی که آلودگی مطرح می‌باشد، کاربرد خواهند داشت. کمپرسورهای گاز اسکرو عاری از روغن قابلیت فشرده سازی گازهای فرآیندی تا فشار خروجی 45 بار و همچنین ایجاد اختلاف فشار 15 را دارند.پکیج کمپرسورهای گاز فرآیندی شرکت هوایار در موارد ذیل قابل استفاده می‌باشند: فشرده سازی مجدد بخارات گازی در فرآیند، فرایندهای مایع سازی گاز، فرایند بازیابی گازهای فلر، فرایند جمع آوری گاز، فشرده سازی گازهای ترش",
        imageAddress: "../assets/images/sample/ScrewGas.jpg",
        imageSquareAddress: "../assets/images/sample/ScrewGasSquare.jpg",
        url: "/ProductDetail",
        category: { value: "1", label: "کمپرسور" },
        equpment: "کمپرسور",
        compressorParameters: {
            isAir:"false",
            isGas: "true",
            isOilInject :"true",
            compresorType: "1",
            motorPower: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
            coolingSystem: [1, 2],
            beltDrive: [1, 2, 3]
        },
        tankParameters: {
            size: ""
        },
        isHasCatalog: "true",
        isHasDataSheet: "false",
        catalogUrl: "../assets/pdf/ScrewGasCompressor.pdf",
        dataSheetUrl: "",
        detailTitle1: "Power",
        detailDescription1: "(Kw) Up to 4,000",
        detailTitle2: "Pressure",
        detailDescription2: "(bar-g)up to 15",
        detailTitle3: "Flow",
        detailDescription3: "(m³/h)up to 24,000 "
    },
    {
        key: "bed73f40-8a8e-11ed-a1eb-0242ac120002",
        id: "2",
        title: "کمپرسور سانتریفیوژ",
        descriptoin: "کمپرسور‌های سانتریفیوژ یا گریز از مرکز (Centrifugal Compressor)، از نوع کمپرسورهای دینامیکی با قابلیت ایجاد نسبت فشارهای متوسط و دبی بالا بوده و اصول حاکم بر طراحی و ساخت هر یک از قطعات آن بر مبنای استاندارد API 617 وAPI 672 می‏باشد. هوا از طریق دهانه مکش مجهز به سیستم فیلتراسیون و با تنظیمات جریان ورودی توسط شیر کنترلی ورودی (IGV: INLET GUIDE VANE) به داخل محفظه مرحله اول مکیده شده و با استفاده از پره‌های ایمپلر به سمت مرکز آن رانده شده و توسط نیروهای گریز از مرکز به سوی محیط ایمپلر به بیرون پرتاب می‌شود.در واقع با استفاده از نیروی گریز از مرکز مقدار فشار سیال طی عبور از ایمپلر افزایش می‌یابد.",
        briefTitle: "اطلاعات فنی",
        briefDescription: "کمپرسور سانتریفوژ تولید شده در شرکت هوایار از نوع کمپرسور سانتریفیوژ Integrally Geared می‌باشد.در این مدل از کمپرسورها، هر کدام از پینیون‌ها می‌توانند در سرعت بهینه کار کنند و بنابراین بازدهی کلی این مدل‌ها از مدل‌های Single shaft بالاتر است.همچنین امکان استفاده از خنک کننده میانی(intercooler) بعد از هر طبقه باعث می‌شود که بهترین بازده ترمودینامیکی برای کل پروسه تراکم را داشته باشیم، در نتیجه با تعداد استیج‌های کمتر نسبت به کمپرسور می‌توانیم به نسبت فشار مورد نظر برسیم.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "کمپرسور سانتریفیوژ integrally geared در شرکت هوایار از توان ۴۵۰ کیلووات تا ۱ مگاوات تولید می‌شود. این کمپرسورها در سه و چهار طبقه امکان تولید فشارهای ۵.۵ الی ۱۳ بار را دارند و ظرفیت هوای ورودی آنها از ۳۰۰۰ تا  ۱۰۰۰۰ نرمال متر مکعب بر ساعت می‌باشد. از دیگر ویژگی‌های کمپرسورهای تولیدی این شرکت، امکان فشرده سازی هوا تا فشار مورد نظر در محدوده دبی وسیعی است، به طوری که پارامتر TURN DOWN RATIO برای کمپرسورهای تولیدی هوایار بین ۲۰ تا ۳۵ درصد می‌باشد. مزایا: ۱- بالاترین بهره وری در مقایسه با انواع سایر کمپرسورها ۲- خروجی هوای بی روغن بدون هیچ گونه تجهیزات  کمکی ۳- کمترین تعمیر و نگهداری ۴- خروجی با کیفیت بالا (بدون نوسانات در فشار تخلیه) ۵- قادر به اجرای مداوم برای مدت زمان طولانی",
        imageAddress: "../assets/images/sample/centrifugeCompressor.jpg",
        imageSquareAddress: "../assets/images/sample/centrifugeCompressorSquare.jpg",
        url: "/ProductDetail",
        category: { value: "1", label: "کمپرسور" },
        equpment: "کمپرسور",
        compressorParameters: {
            isAir:"true",
            isGas:"false",
            compresorType: "2",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: ""
        },
        isHasCatalog: "true",
        isHasDataSheet: "false",
        catalogUrl: "../assets/pdf/Centrifugal-Compressors.pdf",
        dataSheetUrl: "",
        detailTitle1: "Stage",
        detailDescription1: "Single & Multi",
        detailTitle2: "Pressure",
        detailDescription2: "(bar-g)4~75",
        detailTitle3: "Flow",
        detailDescription3: "(m³/min)50~10000"
    },
    {
        key: "bed73f40-8a8e-12ed-a1eb-0242ac120002",
        id: "16",
        title: "کمپرسور سانتریفیوژ گاز",
        descriptoin: "طیف وسیعی از کمپرسور های سانتریفیوژ براساس استاندارد API 617 طراحی و تأمین می‌گردد. کمپرسور گاز فرآیندی سانتریفیوژ Single Shaft با قابلیت عملکرد بالا و هزینه تعمیراتی پایین در صنایع نفت و پالایش، پتروشیمی، فولاد و پلنت‌های سیمانی و همچنین حمل و نقل استفاده می‌گردد. این کمپرسورها با محرکه الکتروموتور یا درایورهای توربینی (بخار و گاز) به کار می‌رود و مجهز به سیستم کنترل PLC در جهت رفع نیاز پروژه و همچنین مطابق با فشارها و ظرفیت‌های متفاوت مورد نیاز کارفرما می‌باشد.",
        briefTitle: "اطلاعات فنی",
        briefDescription: "کمپرسورهای گریز از مرکز با برش افقی پوسته به ویژه برای گازهای قابل اشتعال، سمی یا انفجاری مورد استفاده در همه شاخه‌های صنعت و در همه مواردی که باید از سیل بیرونی هرمتیک استفاده شود به کار می‌رود. کمپرسورهای سانتریفیوژ پوسته افقی قابلیت فشرده سازی گازها با دما پایین ورودی و منفی مورد نیاز برای سرویس‌های گاز (boil-off) در صنعت LNG را دارد. کمپرسور سانتریفیوژ با پوسته افقی این اجازه را به کاربر می‌دهد تا به کلیه اجزای داخلی کمپرسور به راحتی دسترسی داشته و بازرسی و تعمیرات را بدون نیاز به برداشتن پوسته اصلی کمپرسور از صفحه پایه نگهدارنده یا جدا کردن خطوط پایپینگ فرایندی گاز انجام دهد. با توجه به مشخصات فرایندی پروژه، به صورت آپشنال، پره (IGV)  قابل تنظیم در پروانه ورودی کمپرسور (Impeller) برای استیج اول می‌تواند بازده انرژی را تحت شرایط متفاوت کمپرسور بهینه نماید.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "موارد کاربردی کمپرسورهای سانتریفیوژ سینگل شفت :واحدهای تولید نفت به صورت On-Shore و Off-shore، توزیع گاز طبیعی، ذخیره سازی و بازیابی، گاز مایع طبیعی، پتروشیمی‌ها، واحدهای الفین و PDH، پالایشگاه‌ها، پلنت‌های کود شیمیایی (اوره و آمونیوم)، پلنت‌های متانول",
        imageAddress: "../assets/images/sample/GasReciprocatingCompressor.jpg",
        imageSquareAddress: "../assets/images/sample/GasCentrifugalCompressorSquare.jpg",
        url: "/ProductDetail",
        category: { value: "1", label: "کمپرسور" },
        equpment: "کمپرسور",
        compressorParameters: {
            isAir:"false",
            isGas:"true",
            compresorType: "2",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: ""
        },
        isHasCatalog: "true",
        isHasDataSheet: "false",
        catalogUrl: "../assets/pdf/CentrifugalGasCompressor.pdf",
        dataSheetUrl: "",
        detailTitle1: "Mass Flow",
        detailDescription1: "up to 300,000 (m³/h)",
        detailTitle2: "Pressure",
        detailDescription2: "(bar-g)up to 150 ",
        detailTitle3: "Power input",
        detailDescription3: "Up to 25 MW"
    },
    {
        key: "bed7412a-8a8e-11ed-a1eb-0242ac120002",
        id: "3",
        title: "مخزن هوای فشرده",
        descriptoin: "مخزن هوای فشرده (Pressure Vessel) که به عنوان مخازن هوای مرطوب (Wet) و خشک (Dry) در پکیج‌های هوای فشرده شناخته می‌شوند، یکی از کاربردی‌ترین تجهیزات در سیستم های هوای فشرده می‌باشند که در واحدهای بزرگ صنعتی و نیمه صنعتی مورد استفاده قرار می‌گیرد.",
        briefTitle: "کاربرد مخازن هوای فشرده",
        briefDescription: "۱- مخازن به علت سطح تماس گسترده‌ای که با هوای محیط دارند، باعث خنک شدن هوای فشرده می‌شوند و بخشی از رطوبت موجود در هوا را به صورت قطرات آب ته نشین می‌کنند.  ۲- نوسانات فشار (Pulsation) را که در شبکه هوا بوجود می‌آید را کنترل کرده، جریان هوا را آرام نموده و فشار شبکه هوای فشرده را ثابت نگه می‌دارند. در حقیقت مخازن هوای فشرده باعث می‌شوند تا از ایجاد افت فشار ناگهانی در محل مصرف جلوگیری شود. ۳- در صورتی که در خروجی کمپرسورها از مخزن هوای فشرده یا همان مخزن (wet) استفاده نشود؛ فاصله زمانی بین لود و آنلود شدن کمپرسور را کاهش داده و این امر منجر به فشار بیشتر به دستگاه و استهلاک بیشتر قطعات متحرک داخلی کمپرسور می‌شود.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "توجه ویژه به کیفیت بالای مخازن و عمر بالای آنها طراحی مخازن بر اساس استاندارد ASME و استانداردهای معتبر ، جوشکاری کاملاً استاندارد توسط جوشکارهای مجرب و دارای گواهینامه‌های معتبر ، رنگ اپوکسی سه لایه(پلی یورتان + پلی آمید + پلی یورتان) و مقاوم در برابر خوردگی(در نظر گرفتن ضریب خوردگی در زمان طراحی) انجام تست‌های RT, UT, PT بر روی مخازن طراحی ویژه برای شرایط خاص و طبق درخواست مشتری. محاسبه سایز مخزن هوای فشرده از اهمیت بالایی برخوردار است. در صورتی که مخزن بیش از اندازه بزرگ باشد می‌تواند منجر به قرارگیری بیش از حد کمپرسور در حالت آنلود (unload)شود در صورتی که کمپرسور بیش از زمان تعریف شده در حالت آنلود باقی بماند به فاز stand by رفته و موتور کمپرسور خاموش می‌شود و تا زمانی خاموش می‌ماند تا فشار مخزن کم شود و کمپرسور مجددا load شود این امر در طولانی مدت می تواند منجر به آسیب به سیستم برق کمپرسور شود.",
        imageAddress: "../assets/images/sample/airTank.jpg",
        imageSquareAddress: "../assets/images/sample/sairTank.jpg",
        url: "/ProductDetail",
        category: { value: "2", label: "مخزن هوای فشرده" },
        equpment: "مخزن هوای فشرده",
        compressorParameters: {
            compresorType: "",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: "10000"
        },
        isHasCatalog: "false",
        isHasDataSheet: "false",
        catalogUrl: "",
        dataSheetUrl: "",
        detailTitle1: "کاربرد اول",
        detailDescription1: "خنک کردن هوای فشرده",
        detailTitle2: "کاربرد دوم",
        detailDescription2: "کنترل نوسانات فشار",
        detailTitle3: "کاربرد سوم",
        detailDescription3: "کاهش فشار روی کمپرسور"
    },
    {
        key: "bed74670-8a8e-11ed-a1eb-0242ac120002",
        id: "4",
        title: "درایر جذبی",
        descriptoin: "کیفیت هوای فشرده پارامتری کلیدی در صنعت هوای فشرده به شمار می رود. با توجه به اینکه هوای خروجی از کمپرسورها شامل میزان قابل توجهی رطوبت است، این میزان رطوبت می تواند اثرات مخربی را بر ادوات پایین دستی نظیر ابزار دقیق،نیتروژن ساز، اکسیژن ساز و … داشته باشد. برای کاهش هزینه اثرات مخرب رطوبت هوای فشرده، استفاده از سیستم‌های درایر هوا توصیه می شود. درایر های هوای (Air Dryers) ساخته شده توسط گروه صنعتی هوایار در مدل های ذیل عرضه می شود",
        briefTitle: "کارکرد درایر",
        briefDescription: "رطوبت می‌تواند به روش‌های مختلفی وارد دستگاه فشرده سازی هوا شود. کمپرسور هوای شما ممکن است قطعات خرابی داشته باشد که باعث جذب رطوبت بیشتر از هوای اطراف شما می‌شود. محیط عملیاتی که در آن از کمپرسور استفاده می‌شود نیز تفاوت ایجاد می‌کند. اگرچه مقداری رطوبت همیشه وجود دارد، اما مقدار زیاد آن می‌تواند باعث زنگ زدگی، خوردگی و آلودگی هوای فشرده شما شود. هوای فشرده با کیفیت پایین می تواند به محصول نهایی یا استفاده نهایی شما آسیب برساند از این رو برای کاهش میزان رطوبت در هوای فشرده، و برای افزایش عمر دستگاه، یک خشک کن (درایر هوا) هوای فشرده بسیارنقش مهمی دارد. درایر(خشک کن) هوای فشرده دستگاهی است که برای کاهش قابل توجه‌ای رطوبت هوای فشرده طراحی شده است.علاوه بر ایجاد محیط کار ایمن تر و بهداشتی تر برای کارمندان، خشک کن های(درایرها) Dryers هوا، آلودگی هوای فشرده را به حداقل می‌رسانند.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "انتخاب درایر مناسب همواره با یک چالش مهم در صنایع مختلف تبدیل شده است. دانستن تفاوت‌های کلیدی بین این درایرها و نحوه عملکرد آنها می‌تواند کمک شایانی به انتخاب آگاهانه میان آنها نماید. برای انتخاب درایر مناسب باید به نکات زیر توجه داشت: ۱- دمای هوای فشرده ۲- نقطه شبنم دستگاه ۳- فشار کارکرد دستگاه ۴- بیشترین دمای محیط ۵- کاربرد هوای فشرده تولیدی ۶- حجم هوا و حداکثر فشار مورد نیاز ۷- دما و سطح رطوبت مورد نیاز برای کاربرد مورد نظر ۸- چگونگی تغییر این پارامترها مطابق با شرایط محیطی یا برنامه‌های کاربردی ۹- نوع لوازم جانبی یا ابزارهای پنوماتیک مورد استفاده شده در کنار سیستم هوای فشرده",
        imageAddress: "../assets/images/sample/dryer.jpg",
        imageSquareAddress: "../assets/images/sample/DryerSquare.jpg",
        url: "/ProductDetail",
        category: { value: "3", label: "درایر" },
        equpment: "درایر",
        compressorParameters: {
            isAir: "true",
            isGas: "true",
            isRefrigation:"false",
            compresorType: "",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: ""
        },
        isHasCatalog: "true",
        isHasDataSheet: "false",
        catalogUrl: "../assets/pdf/DesiccantDryer.pdf",
        dataSheetUrl: "",
        detailTitle1: "انواع درایر",
        detailDescription1: "تبریدی",
        detailTitle2: "انواع درایر",
        detailDescription2: "جذبی هیتر دار",
        detailTitle3: "انواع درایر",
        detailDescription3: "جذبی بدون هیتر"
    },
    //{
    //    key: "bed74ecc-8a8e-11ed-a1eb-0242ac120002",
    //    id: "7",
    //    title: "کمپرسور رفت و برگشتی",
    //    descriptoin: "کمپرسور رفت و برگشتی دارای بازده خوبی می‌باشند از این رو که رینگ‌های پیستون آب بندی خوبی را انجام می‌دهند و همچنین انتقال حرارت بسیار پایین باعث می‌شود تا بازده کمپرسور رفت و برگشتی بسیار نزدیک به آیزنتروپیک باشد. در کمپرسورهای سرعت پایین، بازده 85 تا 95 درصد یک عدد معمول است و در کمپرسورهای سرعت بالا این مقدار بین 80 تا 90 درصد می‌باشد. بازده مکانیکی نیز که ناشی از اصطکاک و افت‌های سازه‌ای است معمولاً 95 تا 98 درصد می‌باشد. سایر انواع کمپرسور رفت و برگشتی از این حیث در جایگاه پایین‌تری قرار دارند و در واقع بازده کمتر و نشتی (Leakage) بیشتری را خواهند داشت.",
    //    briefTitle: "آرایش سیلندرها در کمپرسور رفت و برگشتی",
    //    briefDescription: "از انواع دیگر کمپرسور رفت و برگشتی که کمتر مورد استفاده هستند آرایش‌های V، W، L و آرایش شعاعی می‌باشد که به صورت تجربی با کراس هد یا بدون کراس هد برای فشرده سازی هوا یا گاز طبیعی استفاده شده‌اند و امروزه کمتر مورد استفاده هستند. کمپرسور رفت و برگشتی عمودی برای فرآیندهای گاز طبیعی و سایر گازها در حالت روغنکاری شده و غیر روغنی با آب بند لبیرنت(Labyrinth) برای پیستون‌ها نیز یکی از آرایش‌های رایج کمپرسورهای می‌باشد.در کمپرسورهای لبیرنت دیگر پیستون رینگ برای آب بندی وجود ندارد و البته برای کارکرد باید به صورت عمودی قرار گیرند.کمپرسورهای عمودی معمولاً در کاربردهای گاز خشک مورد استفاده است زیرا ساختار عمودی امکان نشت مایعات را کمتر می‌کند.کمپرسورهای لبیرنتی معمولاً در توان‌های 12 مگاوات و بالاتر برای تراکم گاز خشک استفاده می‌شوند و برای تراکم هیدروژن که امکان نشت بالایی دارد، کاربرد ندارند.کمپرسورهای عمودی علاوه بر اینها فضای کمتری را در سطح اشغال می‌کنند اما امکان دسترسی(Maintenance) در زمان تعمیرات را مشکل‌تر می‌کنند.",
    //    secondBriefTitle: "اطلاعات تکمیلی",
    //    secondBriefDescription: "کمپرسور رفت و برگشتی معمولاً در کدام شرایط عملکردی استفاده می‌شوند؟ کمپرسورهای رفت و برگشتی معمولاً در شرایطی به کار می‌روند که نسبت فشار بالا و در عین حال فلوی کم مورد نیاز بوده و سیال فرآیندی نسبتاً خشک(dry) باشد.کمپرسور رفت و برگشتی به چند دسته تقسیم می‌شوند؟ کمپرسورهای رفت و برگشتی بسته به نوع تقسیم بندی می‌توانند به انواع کراس هد دار و بدون کراس هد، Single act یا double act و یا بر حسب آرایش سیلندرها به صورت Horizontally opposed یا V- type و… تقسیم شوند.",
    //    imageAddress: "../assets/images/sample/p.jpg",
    //    imageSquareAddress: "../assets/images/sample/pSuare.jpg",
    //    url: "/ProductDetail",
    //    category: { value: "1", label: "کمپرسور" },
    //    equpment: "کمپرسور",
    //    compressorParameters: {
    //        isAir:"true",
    //        isGas:"false",
    //        compresorType: "3",
    //        motorPower: [],
    //        coolingSystem: [],
    //        beltDrive: []
    //    },
    //    tankParameters: {
    //        size: ""
    //    },
    //    isHasCatalog: "true",
    //    isHasDataSheet: "false",
    //    catalogUrl: "../assets/pdf/ReciprocatingCompressor.pdf",
    //    dataSheetUrl: "",
    //    detailTitle1: "Power",
    //    detailDescription1: "Up to 2 MW",
    //    detailTitle2: "Range",
    //    detailDescription2: "Up to 450000 (m³/min), 600 (bar-g)",
    //    detailTitle3: "Stage",
    //    detailDescription3: "Single & Multi"
    //},
    {
        key: "bed74ecc-8a8e-11ed-a1eb-0242ac120002",
        id: "17",
        title: "کمپرسور رفت و برگشتی گاز",
        descriptoin: "کمپرسور رفت و برگشتی دارای بازده خوبی می‌باشند از این رو که رینگ‌های پیستون آب بندی خوبی را انجام می‌دهند و همچنین انتقال حرارت بسیار پایین باعث می‌شود تا بازده کمپرسور رفت و برگشتی بسیار نزدیک به آیزنتروپیک باشد. در کمپرسورهای سرعت پایین، بازده 85 تا 95 درصد یک عدد معمول است و در کمپرسورهای سرعت بالا این مقدار بین 80 تا 90 درصد می‌باشد. بازده مکانیکی نیز که ناشی از اصطکاک و افت‌های سازه‌ای است معمولاً 95 تا 98 درصد می‌باشد. سایر انواع کمپرسور رفت و برگشتی از این حیث در جایگاه پایین‌تری قرار دارند و در واقع بازده کمتر و نشتی (Leakage) بیشتری را خواهند داشت.",
        briefTitle: "آرایش سیلندرها در کمپرسور رفت و برگشتی",
        briefDescription: "از انواع دیگر کمپرسور رفت و برگشتی که کمتر مورد استفاده هستند آرایش‌های V، W، L و آرایش شعاعی می‌باشد که به صورت تجربی با کراس هد یا بدون کراس هد برای فشرده سازی هوا یا گاز طبیعی استفاده شده‌اند و امروزه کمتر مورد استفاده هستند. کمپرسور رفت و برگشتی عمودی برای فرآیندهای گاز طبیعی و سایر گازها در حالت روغنکاری شده و غیر روغنی با آب بند لبیرنت(Labyrinth) برای پیستون‌ها نیز یکی از آرایش‌های رایج کمپرسورهای می‌باشد.در کمپرسورهای لبیرنت دیگر پیستون رینگ برای آب بندی وجود ندارد و البته برای کارکرد باید به صورت عمودی قرار گیرند.کمپرسورهای عمودی معمولاً در کاربردهای گاز خشک مورد استفاده است زیرا ساختار عمودی امکان نشت مایعات را کمتر می‌کند.کمپرسورهای لبیرنتی معمولاً در توان‌های 12 مگاوات و بالاتر برای تراکم گاز خشک استفاده می‌شوند و برای تراکم هیدروژن که امکان نشت بالایی دارد، کاربرد ندارند.کمپرسورهای عمودی علاوه بر اینها فضای کمتری را در سطح اشغال می‌کنند اما امکان دسترسی(Maintenance) در زمان تعمیرات را مشکل‌تر می‌کنند.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "کمپرسور رفت و برگشتی معمولاً در کدام شرایط عملکردی استفاده می‌شوند؟ کمپرسورهای رفت و برگشتی معمولاً در شرایطی به کار می‌روند که نسبت فشار بالا و در عین حال فلوی کم مورد نیاز بوده و سیال فرآیندی نسبتاً خشک(dry) باشد.کمپرسور رفت و برگشتی به چند دسته تقسیم می‌شوند؟ کمپرسورهای رفت و برگشتی بسته به نوع تقسیم بندی می‌توانند به انواع کراس هد دار و بدون کراس هد، Single act یا double act و یا بر حسب آرایش سیلندرها به صورت Horizontally opposed یا V- type و… تقسیم شوند.",
        imageAddress: "../assets/images/sample/GasReciprocatingCompressor.jpg",
        imageSquareAddress: "../assets/images/sample/GasReciprocatingCompressorSquare.jpg",
        url: "/ProductDetail",
        category: { value: "1", label: "کمپرسور" },
        equpment: "کمپرسور",
        compressorParameters: {
            isAir:"false",
            isGas:"true",
            compresorType: "3",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: ""
        },
        isHasCatalog: "true",
        isHasDataSheet: "false",
        catalogUrl: "../assets/pdf/ReciprocatingCompressor.pdf",
        dataSheetUrl: "",
        detailTitle1: "Power",
        detailDescription1: "Up to 2 MW",
        detailTitle2: "Range",
        detailDescription2: "Up to 450000 (m³/min), 600 (bar-g)",
        detailTitle3: "Stage",
        detailDescription3: "Single & Multi"
    },
    {
        key: "bed83daa-8a8e-11ed-a1eb-0242ac120002",
        id: "8",
        title: "اکسیژن ساز",
        descriptoin: "برای اکسیژن سازهای با ظرفیت کم تا متوسط، شرکت هوایار در محصولات خود از تکنولوژی مبتنی بر Pressure Swing Adsorption یا PSA که یک روش تولید اکسیژن در محل مصرف کننده است، استفاده می‌نماید. تولید اکسیژن در دستگاه‌های PSA براساس عبور هوای فشرده از گرانول‌های زئولیت مصنوعی که به آن غربال مولکولی(MOLECULAR SIEVE) می‌گویند، انجام می‌گیرد.نیتروژن موجود در هوا ضمن عبور از زئولیت، به دام می‌افتد و اکسیژن هوا در فشار پایین(در حدود ۴ تا ۶ بار گیج) آزاد می‌شود.این امر به طور کلی منجر به تولید اکسیژن به طور مداوم می‌گردد. عمل جداسازی اکسیژن از هوا یک فرآیند فیزیکی است و در آن هیچ گونه فعل و انفعال شیمیایی صورت نمی‌گیرد و به محض برداشتن فشار از گرانول‌های زئولیت(جزئی از فرآیند داخلی اکسیژن ساز)، گاز نیتروژن تخلیه و زئولیت به حالت اولیه خود باز می‌گردد به عبارتی دیگر زئولیت مجدداً احیا می‌شود. ",
        briefTitle: "مزایای تولید اکسیژن به روش PSA",
        briefDescription: "۱- هزینه (کنترل کامل هزینه را در اختیار دارید) ۲- تولید در محل مصرف کننده ۳- فشار اکسیژن ۴- دسترسی ۵- کیفیت اکسیژن ۶- اتصال به خط لوله بیمارستان ۷- نگهداری آسان ۸- فیلتراسیون پیشرفته ۹- عملکرد ۱۰۰% اتوماتیک بدون نیاز به اپراتور",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "در زمینه‌ی طراحی و تولید پکیج‌های اکسیژن اقدامات ذیل در گروه صنعتی هوایار انجام می‌شود: ۱- مهندسی و طراحی دقیق پکیج بر اساس نیاز مشتری ۲- هماهنگی و کنترل تأمین کنندگان بر اساس درخواست مشتری ۳- بازرسی و تست تجهیزات و قطعات مصرفی ۴- تولید تمامی مدارک فنی مورد نیاز پروژه ۵- برگزاری جلسات بررسی طراحی، چیدمان، ساخت، بهره برداری و نگهداری ۶- پیش راه اندازی، راه اندازی و آموزش نیروهای کارفرما",
        imageAddress: "../assets/images/sample/O2Generator.jpg",
        imageSquareAddress: "../assets/images/sample/O2GeneratorSquare.jpg",
        url: "/ProductDetail",
        category: { value: "4", label: "اکسیژن ساز" },
        equpment: "اکسیژن ساز",
        compressorParameters: {
            compresorType: "",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: "20"
        },
        isHasCatalog: "true",
        isHasDataSheet: "false",
        catalogUrl: "../assets/pdf/oxygen_generator_package_havayar.pdf",
        dataSheetUrl: "",
        detailTitle1: "نوع اول",
        detailDescription1: "دو برجه",
        detailTitle2: "نوع دوم",
        detailDescription2: "ماژولار",
        detailTitle3: "نوع سوم",
        detailDescription3: "پرتابل"
    },
    {
        key: "bed83db9-8a8e-11ed-a1eb-0242ac120002",
        id: "9",
        title: "نیتروژن ساز",
        descriptoin: "ژنراتور نیتروژن (Nitrogen Generator) هوایار به روش PSAطراحی شده است. نیتروژن 78٪ از جو را تشکیل داده و شکل مایع آن سبک تر از آب و شکل گازی آن، سبک تر از هوا است. دارای حلالیت پایین در آب است. این گاز بی رنگ، بی بو و بی مزه نقش مهمی در صنایع مختلف از قبیل صنایع شیمیایی، آفت کش ها، صنعت سیمان، صنعت کاغذ، صنعت داروسازی، مواد غذایی و صنایع ساخت نوشابه، صنعت هوانوردی، صنعت الکترونیک، صنعت بافندگی و غیره بازی می کند … و هر صنعتی که از نیتروژن استفاده می کند نیاز به ژنراتور نیتروژن دارد.",
        briefTitle: "تولید نیتروژن به روش PSA",
        briefDescription: "در این روش که یکی از متداول‌ترین روش‌های تولید نیتروژن می‌باشد. ابتدا هوای فشرده‌ی تولید شده توسط کمپرسور پس از عبور از تجهیزاتی همچون درایر و فیلترها، رطوبت و آلودگی خود را از دست داده وسپس هوای کاملاً خشک و فشرده وارد برج‌های ژنراتور نیتروژن می‌شود. ژنراتور نیتروژن از حداقل دو برج تشکیل شده است که برج‌های آن حاوی کربن‌های مخصوصی بنام کربن مولکولارسیو با سطوح متخلخل کاملاً منظم با قطر حفره‌های 4 انگسترومی هستند از آنجا که قطر مولکولی اکسیژن 3.8 انگستروم و قطر مولکولی نیتروژن 4.2 انگستروم می‌باشد مولکول‌های ریزتر اکسیژن در زمانی که برج‌های ژنراتور نیتروژن تحت فشار قرار می‌گیرند توان نفوذ به داخل حفره‌های ریز 4 انگسترومی کربنی را یافته و در ان به دام می‌افتند و بنابراین مولکول‌های نیتروژن از لابلای مواد کربنی با خلوص معینی ازبالای برج ژنراتور نیتروژن خارج می‌شوند.و پس از طی مدت معینی بسته به اندازه ژنراتور نیتروژن و دبی خروجی، CMS ها از اکسیژن اشباع می‌شوند و باید با خالی شدن هوای فشرده داخل برج ها، از منافذ کربنی بیرون امده و از مسیر سایلنسر موجود در ژنراتور نیتروژن خارج شوند.فرآیند احیا به ژنراتور نیتروژن کمک می‌کند تا برجی که اکسیژن را جذب و اشباع شده مجدداً شرایط خود را باز یافته و آماده‌ی تولید نیتروژن شود بنابراین همواره در تولید نیتروژن با پکیج PSA ، در هر دستگاه حداقل از دو برج استفاده می‌شود که در زمانیکه یک برج در حال احیا شدن است برج دوم عمل تولید نیتروژن را انجام دهد و کنترل ولوها و باز و بسته شدن آنها توسط سیستم کنترل دستگاه انجام می‌گیرد.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "میزان دبی و خلوص تولید شده در ژنراتور نیتروژن های شرکت هوایار بسیار متنوع بوده و این شرکت در محصولات روتین خود نیتروژن سازهایی با فلوی تا  Sm 3 /hr  5000 و میزان خلوص تا 99.9999 تولید و استحصال می‌نماید. در ژنراتور نیتروژن فشار هوای ورودی دستگاه تا میزان حداکثر 10 بار گیج مجاز می‌باشد و این ژنراتور نیتروژن قادر به تولید نیتروژن از 5 بار گیج تا 8 بارگیج را دارند.            نکته: در این روش فرآوری و خشک بودن هوای فشرده ورودی بسیار مهم بوده و چنانچه از فیلترهای مناسب استفاده نشود رطوبت و بخصوص روغن معلق در هوای فشرده ورودی ژنراتور نیتروژن به سرعت وارد در ژنراتور نیتروژن شده و منافذ کربن را می‌پوشاند و ازجذب اکسیژن توسط مواد CMS موجود در دستگاه جلوگیری کرده و در نتیجه مواد CMS ژنراتور نیتروژن را تخریب و بشدت خلوص نیتروژن خروجی را کاهش می‌دهد.",
        imageAddress: "../assets/images/sample/N2Generator2.jpg",
        imageSquareAddress: "../assets/images/sample/N2Generator2square.jpg",
        url: "/ProductDetail",
        category: { value: "5", label: "نیتروژن ساز" },
        equpment: "نیتروژن ساز",
        compressorParameters: {
            compresorType: "",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: "20"
        },
        isHasCatalog: "true",
        isHasDataSheet: "false",
        catalogUrl: "../assets/pdf/GasGenerationAndParification.pdf",
        dataSheetUrl: "",
        detailTitle1: "نوع اول",
        detailDescription1: "دو برجه",
        detailTitle2: "نوع دوم",
        detailDescription2: "ماژولار",
        detailTitle3: "نوع سوم",
        detailDescription3: "پرتابل"
    },
    {
        key: "bed84bd7-8a8e-11ed-a1eb-0242ac120002",
        id: "10",
        title: "فیلتر کربن - Coal Tower",
        descriptoin: "وظیفه برج کربن فعال جذب بخارات روغن و بوی نامطبوع هوای فشرده خروجی از کمپرسور می‌باشد. در هوای فشرده همیشه مقداری آب، غبار، ذرات معلق و روغن وجود دارد که وقتی با هم مخلوط می‌شوند هوای فشرده کثیف اسیدی بوجود می‌آورند که باعث فرسایش ماشین آلات پنوماتیک، مسدود کردن شیرآلات و فرسایش لوله‌ها می‌شوند که هزینه‌های سنگینی را در بر دارد. همه این مشکلات به سادگی می‌تواند توسط سیستم فیلتراسیون تعبیه شده مرتفع گردد. سیستم فیلتراسیون شامل فیلتر هوای ورودی (Pre-filters) ، فیلتر سپراتور و روغن، تله آبگیر (Water Separator) و میکرو فیلترها (Micro filters)  می‌باشد .فیلتر کربن که از کربن اکتیو یا کربن فعال پر شده است، جاذب بخارات روغن می‌باشد. وظیفه برج کربن فعال جذب بخارات روغن و بوی نامطبوع هوای فشرده خروجی از کمپرسور اسکرو تا حد 0.003mg/m3  ( 0.003ppm) می‌باشد.",
        briefTitle: "سایر اطلاعات",
        briefDescription: "هوای فشرده‌ای که از کمپرسور اسکرو خارج می‌شود دارای بوهای نامطبوع و ذرات و بخارات بسیار ریز روغن است فیلترهای مختلف سپراتور و اولیه و ثانویه، تا حدود بسیار زیادی آلودگی‌ها و ذرات روغن را از آن جدا خواهند کرد. اما لازم است که همان میزان بسیار کم بخارات روغن باقی مانده نیز از هوا گرفته شود. در نتیجه بهترین دستگاه برای جذب بخارات روغن از کمپرسورهای باد اسکرو تا اندازه 0.003ppm، برج کربن اکتیو می‌باشد. فیلتر کربن بعد از کمپرسور نصب می‌گردد و کیفیت هـوای خروجی از آن را می‌توان به وسیله نشانگر روغن  (Oil Indicator) مشاهده نمود.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "در صنایعی مانند بیمارستان‌ها، مواد غذایی، دارویی، پزشکی، پتروشیمی، الکترونیکی و … هوای فشرده با خلوص و کیفیت بالا بسیار حائز اهمیت است و در صورت وجود بوهای نامطبوع و بخارات روغن در هوا، ممکن است مشکلاتی در سلامتی افراد به وجود بیاید و جان انسان‌ها را به خطر بیندازد. در نتیجه حتماً در تولید هوای فشرده با کیفیت بالا باید از برج کربن اکتیو استفاده شود. برج کربن فعال از مواد کربن خاصی تشکیل شده است و زمانی که هوای فشرده از قسمت بالای برج به سمت پایین آن حرکت می‌کند، بوهای نامطبوع و ذرات ریز روغن آن توسط این مواد جذب خواهند شد. همچنین این برج دارای مدل‌های متنوعی است که میزان کربن فعال هر کدام متناسب با ابعاد و هوای عبوری و … متفاوت است.از معروف‌ترین این برج‌ها، برج های فعال اکتیو میکروپور است که ماکزیمم فشار کاری آنها 10 بار و ماکزیمم دمای پیشنهادی اپراتور نیز 25 درجه سانتی گراد می‌باشد.",
        imageAddress: "../assets/images/sample/CoalTower.jpg",
        imageSquareAddress: "../assets/images/sample/CoalTowerSquare.jpg",
        url: "/ProductDetail",
        category: { value: "6", label: "برج ذغال-Coal Tower" },
        equpment: "برج ذغال",
        compressorParameters: {
            compresorType: "",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: "20"
        },
        isHasCatalog: "true",
        isHasDataSheet: "true",
        catalogUrl: "../assets/pdf/ActivatedCarbonTowersNew.pdf",
        dataSheetUrl: "../assets/pdf/CoalTowersDataSheet.pdf",
        detailTitle1: "نوع اول",
        detailDescription1: "دو برجه",
        detailTitle2: "نوع دوم",
        detailDescription2: "ماژولار",
        detailTitle3: "نوع سوم",
        detailDescription3: "پرتابل"
    },
    {
        key: "bed83daa-8a8e-11ed-a1eb-0242ac120002",
        id: "11",
        title: "فیلتر سپراتور",
        descriptoin: "فیلتر سپراتور (SEPARATOR FILTER) در کمپرسورهای اسکرو به معنای جدا کننده هوا از روغن است. این فیلتر با فیلترهایی که عملکرد آنها جدایش آلودگی‌های موجود در روغن یا هوا است تفاوت دارد. وظیفه آن جدا سازی ذرات روغن از هوا می‌باشد اساس کار این قطعه در کمپرسورهای اسکرو روغنی به این شکل است که هوا بعد از خروج از بلوکه هوا ساز (Airend) جهت فشرده سازی از طریق لاین هوا و روغن وارد مخزن سپراتور می‌شود که این مرحله جریان بصورت دو فازی متشکل از هوا و روغن می‌باشد و برای جدا سازی هوای خروجی از مخزن و روغن نیاز به وجود یک فیلتر جدا کننده دارد که این قطعه این وظیفه را بر عهده دارد.",
        briefTitle: "سایر اطلاعات فنی پکیج",
        briefDescription: "فیلترهای سپراتورها را بر اساس محل قرار گرفتن و شکل کاسه انتهای فیلتر به 2 دسته اصلی طبقه بندی می‌کنیم.فیلتر سپراتور مخزنی(داخلی) این نوع فیلتر در درون مخزن سپراتور تعبیه می‌شوند و در انتهای این نوع از فیلترها به شکل کاسه می‌باشد که محل ذخیره روغن فیلتر شده است و توسط ساکشن لاین تخلیه می‌شود؛ جریان هوا در این فیلتر از خارج به داخل می‌باشد. فیلتر سپراتور کارتریجی(خارجی) و یا اکسترنال بر روی مخزن قرار می‌گیرد که طراحی جدیدتری نسبت به فیلترهای داخل مخزنی است. و با توجه به این که فیلترها بیرون مخزن قرار می‌گیرند نصب و تعویض آنها سریع‌تر و آسان‌تر است.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "پارامترهای مهم در انتخاب فیلتر مناسب شامل (فشار محیط ، فشار کاری،مش بندی فیلتر،،حداکثر میزان فلوی روغن،میزان اختلاف فشار اولیه،ابعاد فیلتر،جنس المنت و بدنه فیلتر، ) میباشند .زمان تعویض فیلتر سپراتورها معمولاً توسط سازنده مشخص می‌شود.فیلتر سپراتور کمپرسورها پس از طی کردن زمان کارکرد مشخص شده اشباع می‌شوند و عملکرد خود را از دست می‌دهد و این باعث بالا رفتن اختلاف فشار داخل و خارج المنت فیلتر می‌شود.معمولاً مدت زمان کارکرد مفید فیلتر سپراتورها بین 1000 تا 4000 ساعت است که به جنس و کیفیت متریال به کار رفته، شرایط محیطی، میزان ذرات آلاینده در هوا و از همه مهم‌تر کیفیت روغن مخصوص به کار رفته در کمپرسور بستگی دارد و مسقیماً با عملکرد کمپرسور و بالا بودن دمای کاری آن مرتبط می‌باشد.اگر در حین کار مشکلی برای آن پیش بیاید توسط ابزار دقیق‌های تعبیه شده بر روی کمپرسور و ست پوینت‌های تعریف شده بر روی تابلو کنترل مشخص می‌شود.در برخی موارد هم با توجه به شرایط مختلف از جمله وجود روغن در خروجی کمپرسور می‌توان متوجه پایین بودن کیفیت یا خرابی آن شد.",
        imageAddress: "../assets/images/sample/filterSeprator.jpg",
        imageSquareAddress: "../assets/images/sample/filterSepratorSquare.jpg",
        url: "/ProductDetail",
        category: { value: "7", label: "فیلتر سپراتور" },
        equpment: "فیلتر سپراتور",
        compressorParameters: {
            compresorType: "",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: "20"
        },
        isHasCatalog: "false",
        isHasDataSheet: "false",
        catalogUrl: "",
        dataSheetUrl: "",
        detailTitle1: "مرحله اول کار",
        detailDescription1: "جداسازی توسط گریز از مرکز",
        detailTitle2: "مرحله دوم کار",
        detailDescription2: "جداسازی توسط لایه‌های میکرو فایبر گلاس",
        detailTitle3: "مرحله سوم کار",
        detailDescription3: "جذب توسط میکرو فیلترها"
    },
    {
        key: "bed83daa-8a8e-11ed-a1eb-0242ac120002",
        id: "12",
        title: "تله آبگیر",
        descriptoin: "تله آبگیر یکی از مهم‌ترین قطعاتی است که برای جداسازی رطوبت موجود در هوا به‌کار رفته و عملکرد کمپرسورها را بهینه می‌کند. این قطعه مکانیکی با کاهش میزان رطوبت و تخلیه آن از بروز خسارات سنگین به ماشین‌آلات جلوگیری می‌کند.",
        briefTitle: "سایر اطلاعات فنی پکیج",
        briefDescription: "تله آبگیر کمپرسور با استفاده از روش سانتریفیوژ یا گریز از مرکز می‌تواند چیزی در حدود 90 درصد قطرات آب موجود در هوا را جداسازی کند. این امر به کاهش آلودگی و افزایش کیفیت هوای خارج شده از کمپرسور کمک می‌کند. مجموع عوامل یاد شده در بهینه‌سازی روند تولید تاثیرگذار خواهد بود. در واقع، رطوبت گیر کمپرسور ابتدا هوای محیط را با کمک پره‌ها و به صورت دورانی به داخل خود کشیده و با ایجاد حرکت چرخشی، ریز قطرات آب موجود در هوا را از آن جدا می‌کند.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "استفاده از تله آبگیر موجب افزایش کیفیت هوای خارج شده از کمپرسور به شکلی مقرون به صرفه‌ای می‌شود. برخورداری از استاندارد مخازن تحت فشار و امکان بهره‌برداری در مراکز حساس، دوام بالا و وزن اندک، امکان تخلیه خودکار، بهبود کیفیت عملکرد کمپرسور با بهره‌گیری از یک مکانیزم ساده، بازدهی بالا، جلوگیری از ایجاد رسوب در خطوط هوای فشرده از مزایای استفاده از تله آبگیر می‌باشد.",
        imageAddress: "../assets/images/sample/waterTrap1.jpg",
        imageSquareAddress: "../assets/images/sample/waterTrap.jpg",
        url: "/ProductDetail",
        category: { value: "8", label: "تله آبگیر" },
        equpment: "تله آبگیر",
        compressorParameters: {
            compresorType: "",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: "20"
        },
        isHasCatalog: "false",
        isHasDataSheet: "false",
        catalogUrl: "",
        dataSheetUrl: "",
        detailTitle1: "نوع اول",
        detailDescription1: "پنوماتیکی",
        detailTitle2: "نوع دوم",
        detailDescription2: "صنعتی",
        detailTitle3: "نوع سوم",
        detailDescription3: "بوشنی یا رزوه‌ای"
    },
    {
        key: "bed74670-8a8e-11ed-a1eb-0242ac120002",
        id: "13",
        title: "درایر تبریدی",
        descriptoin: "کیفیت هوای فشرده پارامتری کلیدی در صنعت هوای فشرده به شمار می رود. با توجه به اینکه هوای خروجی از کمپرسورها شامل میزان قابل توجهی رطوبت است، این میزان رطوبت می تواند اثرات مخربی را بر ادوات پایین دستی نظیر ابزار دقیق،نیتروژن ساز، اکسیژن ساز و … داشته باشد. برای کاهش هزینه اثرات مخرب رطوبت هوای فشرده، استفاده از سیستم‌های درایر هوا توصیه می شود. درایر های هوای (Air Dryers) ساخته شده توسط گروه صنعتی هوایار در مدل های ذیل عرضه می شود",
        briefTitle: "کارکرد درایر",
        briefDescription: "رطوبت می‌تواند به روش‌های مختلفی وارد دستگاه فشرده سازی هوا شود. کمپرسور هوای شما ممکن است قطعات خرابی داشته باشد که باعث جذب رطوبت بیشتر از هوای اطراف شما می‌شود. محیط عملیاتی که در آن از کمپرسور استفاده می‌شود نیز تفاوت ایجاد می‌کند. اگرچه مقداری رطوبت همیشه وجود دارد، اما مقدار زیاد آن می‌تواند باعث زنگ زدگی، خوردگی و آلودگی هوای فشرده شما شود. هوای فشرده با کیفیت پایین می تواند به محصول نهایی یا استفاده نهایی شما آسیب برساند از این رو برای کاهش میزان رطوبت در هوای فشرده، و برای افزایش عمر دستگاه، یک خشک کن (درایر هوا) هوای فشرده بسیارنقش مهمی دارد. درایر(خشک کن) هوای فشرده دستگاهی است که برای کاهش قابل توجه‌ای رطوبت هوای فشرده طراحی شده است.علاوه بر ایجاد محیط کار ایمن تر و بهداشتی تر برای کارمندان، خشک کن های(درایرها) Dryers هوا، آلودگی هوای فشرده را به حداقل می‌رسانند.",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "انتخاب درایر مناسب همواره با یک چالش مهم در صنایع مختلف تبدیل شده است. دانستن تفاوت‌های کلیدی بین این درایرها و نحوه عملکرد آنها می‌تواند کمک شایانی به انتخاب آگاهانه میان آنها نماید. برای انتخاب درایر مناسب باید به نکات زیر توجه داشت: ۱- دمای هوای فشرده ۲- نقطه شبنم دستگاه ۳- فشار کارکرد دستگاه ۴- بیشترین دمای محیط ۵- کاربرد هوای فشرده تولیدی ۶- حجم هوا و حداکثر فشار مورد نیاز ۷- دما و سطح رطوبت مورد نیاز برای کاربرد مورد نظر ۸- چگونگی تغییر این پارامترها مطابق با شرایط محیطی یا برنامه‌های کاربردی ۹- نوع لوازم جانبی یا ابزارهای پنوماتیک مورد استفاده شده در کنار سیستم هوای فشرده",
        imageAddress: "../assets/images/sample/RefrigularDryer.jpg",
        imageSquareAddress: "../assets/images/sample/RefrigularDryerSquare.jpg",
        url: "/ProductDetail",
        category: { value: "3", label: "درایر" },
        equpment: "درایر",
        compressorParameters: {
            isAir: "true",
            compresorType: "",
            isRefrigation: "true",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: ""
        },
        isHasCatalog: "true",
        isHasDataSheet: "false",
        catalogUrl: "../assets/pdf/DesiccantDryer.pdf",
        dataSheetUrl: "",
        detailTitle1: "انواع درایر",
        detailDescription1: "تبریدی",
        detailTitle2: "انواع درایر",
        detailDescription2: "جذبی هیتر دار",
        detailTitle3: "انواع درایر",
        detailDescription3: "جذبی بدون هیتر"
    },
    {
        key: "bed83daa-8a8e-11ed-a1eb-0242ac120002",
        id: "14",
        title: "لاین فیلتر",
        descriptoin: "فیلتر سپراتورفیلترهای هوای فشرده برای محافظت از سیستم هوای فشرده و نصب در پایین دست کمپرسور به منظور بهبود کیفیت هوا طراحی  شده اند. این فیلترها حذف کارآمد ذرات جامد، آب، آئروسل های روغن، هیدروکربن ها، بو و بخارات را از سیستم های هوای فشرده تا 16 بار تضمین می کنند. کیفیت هوای فشرده مورد نیاز طبق استاندارد ISO 8573 با 5 درجه مختلف قابل دستیابی است. برای تخلیه کارآمد میعانات از محفظه فیلتر، باید از شیرهای تخلیه کارآمد با بازدهی بالا استفاده شود.",
        briefTitle: "استفاده در صنایع مختلف",
        briefDescription: "• کاربردهای صنعتی عمومی  • خودرو     • الکترونیک     • خوردنی و آشامیدنی     • شیمیایی   • پتروشیمی  • پلاستیک    • رنگ  ",
        secondBriefTitle: "اطلاعات تکمیلی",
        secondBriefDescription: "پارامترهای مهم در انتخاب فیلتراسیون شامل (فشار کاری ، دمای محیط ، سایز لوله ، مش بندی فیلتر،حداکثر میزان فلوی هوای فشرده،ابعاد و بدنه فیلتر) می باشند. وجود نشانگر اختلاف فشار بر روی فیلترها به بهره برداران کمک می کند تا ضمن آگاهی از افت فشار احتمالی و گرفتگی المنت فیلتر ، برای زمان تعویض المنت برنامه ریزی نمایند.   ",
        imageAddress: "../assets/images/sample/LineFilter.jpg",
        imageSquareAddress: "../assets/images/sample/LineFilterSquare.jpg",
        url: "/ProductDetail",
        category: { value: "9", label: "لاین فیلتر" },
        equpment: "فیلتر",
        compressorParameters: {
            compresorType: "",
            motorPower: [],
            coolingSystem: [],
            beltDrive: []
        },
        tankParameters: {
            size: "20"
        },
        isHasCatalog: "false",
        isHasDataSheet: "false",
        catalogUrl: "",
        dataSheetUrl: "",
        detailTitle1: "",
        detailDescription1: "",
        detailTitle2: "",
        detailDescription2: "",
        detailTitle3: "",
        detailDescription3: ""
    },
];

export function getproducts() {
    return products;
}

export function getProductById(id) {
    if (id === "none")
        return products;
    return products.filter(m => m.id === id);
}

export function getproductsByCategoryId(value) {
    return products.filter(m => m.category.value === value);
}

export function getproductsBySizingParameters(equpment, compressorType, tankType) {
    console.log("getproductsBySizingParameters : equpment : ", equpment, " compressorType: ", compressorType, " tankType : ", tankType);
    if (equpment === "کمپرسور") {
        if (compressorType === "")
            return products.filter(m => m.equpment === equpment);
        if (compressorType === "هوا")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.isAir === "true");
        if (compressorType === "گاز")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.isGas === "true");
        if (compressorType === "OilInject")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.isOilInject === "true" && m.compressorParameters.isAir === "true");
        if (compressorType === "OilFree")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.isOilInject === "false" && m.compressorParameters.isAir === "true");
        if (compressorType === "1")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.compresorType === "1");
        if (compressorType === "2")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.compresorType === "2" && m.compressorParameters.isAir === "true");
        if (compressorType === "3")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.compresorType === "3");
        if (compressorType === "4")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.compresorType === "1" && m.compressorParameters.isGas === "true");
        if (compressorType === "5")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.compresorType === "1" && m.compressorParameters.isAir === "true");
        if (compressorType === "7")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.compresorType === "2" && m.compressorParameters.isGas === "true");
    }
    if (equpment === "2")
        return products.filter(m => m.equpment === equpment && m.tankType === tankType);

    if (equpment === "درایر") {
        if (compressorType === "")
            return products.filter(m => m.equpment === equpment);
        if (compressorType === "هوا")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.isAir === "true");
        if (compressorType === "گاز")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.isGas === "true");
        if (compressorType === "تبریدی")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.isRefrigation === "true");
        if (compressorType === "جذبی")
            return products.filter(m => m.equpment === equpment && m.compressorParameters.isRefrigation === "false");

    }

    return products.filter(m => m.equpment === equpment);
}

export function getScrew(motorPower, coolingType) {
    if (motorPower === "" & coolingType === "")
        return products.filter(m => m.compressorParameters.compresorType === "1");
    if (motorPower !== "0" & coolingType !== "0")
        return products.filter(m => m.compressorParameters.compresorType === "1"
            & m.compressorParameters.coolingSystem.includes(coolingType)
            & m.compressorParameters.motorPower.includes(motorPower)
        );
    if (motorPower !== "0")
        return products.some(m => m.compressorParameters.compresorType === "1"
            & m.compressorParameters.motorPower.includes(motorPower));

    if (coolingType !== "0")
        return products.filter(m => m.compressorParameters.compresorType === "1"
            & m.compressorParameters.coolingSystem.includes(coolingType)
        );
}

export function getSentrifuge() {
    return products.filter(m => m.compressorParameters.compresorType === "2");
}

export function getTank(tank) {
    return products.filter(m => m.compressorParameters.compresorType === tank);
}